"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const useSidebar_1 = __importDefault(require("hooks/useSidebar"));
const Divider_1 = __importDefault(require("components/design-system/Divider"));
require("./SidebarRight.scss");
const SidebarRightContent = ({ disabled, customClass, children, fixed = true, fullWidth, dataCy, customWidth, fullHeight = false }) => {
    const topSidebar = (0, useSidebar_1.default)((state) => state === null || state === void 0 ? void 0 : state.topSidebar);
    // use fixed = false if you already have a container that set the top and height for the sidebar
    const sidebarClass = (0, classnames_template_literals_1.default)(`
        pb-[0px]
        sidebar-right
        shadow-overlay
        rounded
        flex
        flex-col
        bg-n-000
        z-[1000]
        ${customClass}
        ${fixed && 'fixed top-0 right-0'}
        ${fullWidth ? 'w-full' : customWidth ? customWidth : 'w-[640px]'}
    `);
    const sharedSidebar = document.querySelectorAll(`[id^="shared-sidebar"]`)[0];
    const height = fullHeight ? 0 : topSidebar || 0;
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { ref: (el) => {
            if (el) {
                el.style.setProperty('top', `${height}px`, 'important');
                el.style.setProperty('height', `calc(100vh - ${height}px)`);
            }
        }, className: sidebarClass, "data-cy": dataCy },
        disabled && (react_1.default.createElement("div", { className: "fixed w-full h-full cursor-not-allowed z-9999999 overlay-disabled" })),
        children), sharedSidebar);
};
const Header = ({ withSpace = true, children, customClass, useBorder = true }) => {
    const headerClass = (0, classnames_template_literals_1.default)(`
        ${withSpace && 'py-[14px] px-[16px]'}
        ${customClass}
    `);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: headerClass }, children),
        useBorder && react_1.default.createElement(Divider_1.default, null)));
};
// eslint-disable-next-line react/display-name
const Body = (0, react_1.forwardRef)(({ withSpace = true, children, customClass, onScroll = () => null }, ref) => {
    const bodyClass = (0, classnames_template_literals_1.default)(`
        w-full
        grow
        overflow-auto
        ${withSpace && 'py-[16px] px-[16px]'}
        ${customClass}
    `);
    return (react_1.default.createElement("div", { className: bodyClass, onScroll: onScroll, ref: ref }, children));
});
const Footer = ({ withSpace = true, children, customClass }) => {
    const footerClass = (0, classnames_template_literals_1.default)(`
        ${withSpace && 'py-[16px] px-[16px]'}
        ${customClass}
    `);
    return (react_1.default.createElement("div", { className: "w-full" },
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement("div", { className: footerClass }, children)));
};
SidebarRightContent.Header = Header;
SidebarRightContent.Body = Body;
SidebarRightContent.Footer = Footer;
exports.default = SidebarRightContent;
